import { useCallback } from 'react'
import { BlankCondition } from '../../../../../../domain/value-object/WbsItemSearchConditionVo'

type HasBlank = { blank?: BlankCondition }

export const useOnSingleValueChangedGenerator = <
  T extends HasBlank & Record<string, any>,
>(
  searchCondition: T,
  onChange: (updated: Partial<T>) => void
) => {
  const onChangeValueGenerator = useCallback((key: keyof T) => {
    return (value: T[typeof key] | undefined) => {
      const updated = {} as Partial<T>
      ;(updated as any)[key] = value
      onChange(updated)
    }
  }, [])
  const onChangeBlankGenerator = useCallback(
    (key: keyof BlankCondition) => {
      const currentCondition = searchCondition.blank || {}
      return (value: boolean) => {
        const newCondition = {
          ...currentCondition,
        }
        newCondition[key] = value
        onChange({ blank: newCondition } as Partial<T>)
      }
    },
    [searchCondition]
  )

  return {
    onChangeValueGenerator,
    onChangeBlankGenerator,
  }
}
